<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex; font-size: 12px; align-items: center">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
          <span style="margin: 0 5px">业务员</span>
          <employee-select v-model="params.employee_id" @change="getData()" style="width: 120px"></employee-select>
          <span style="margin: 0 5px">标签</span>
          <customer-tag v-model="params.customer_tag" @change="getData()" style="width: 120px"></customer-tag>
          <span style="margin: 0 5px">成交状态</span>
          <el-select size="small" v-model="params.is_succ" clearable placeholder="请选择" @change="getData()" style="width: 100px">
            <el-option label="未成交" :value="0"></el-option>
            <el-option label="待成交" :value="1"></el-option>
            <el-option label="已成交" :value="2"></el-option>
          </el-select>
        </div>
        <el-button size="small" type="primary" @click="dialog()" v-if="$isPerm('customer-save')">添加客户</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="name" label="客户姓名" width="100"></el-table-column>
      <!-- <el-table-column prop="id_card" label="身份证" width="150"></el-table-column> -->
      <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
      <el-table-column prop="customer_tag_name" label="客户标签" width="80"></el-table-column>
      <el-table-column prop="company_name" label="企业名称" width="200" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="corporate_account" label="对公户" width="200" show-overflow-tooltip></el-table-column> -->
      <!-- <el-table-column prop="address" label="经营地址" width="200" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="industry" label="行业" width="120"></el-table-column>
      <el-table-column prop="employee_name" label="业务员" width="100"></el-table-column>
      <el-table-column prop="is_succ" label="成交" width="80">
        <template slot-scope="scope">
          <el-tag type="info" size="mini" v-if="scope.row.is_succ == 0">未成交</el-tag>
          <el-tag type="warning" size="mini" v-else-if="scope.row.is_succ == 1">待成交</el-tag>
          <el-tag type="success" size="mini" v-else-if="scope.row.is_succ == 2">已成交</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column label="创建时间" width="135">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="135">
        <template slot-scope="scope">
          <span>{{ scope.row.update_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="info" @click="dialog(scope.row, true)" v-if="$isPerm('customer-info')">查看</el-button>
          <el-button size="mini" type="primary" @click="dialog(scope.row)" v-if="$isPerm('customer-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('customer-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="770px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <customer-save ref="customerSaveRef" @callMethod="refresh" :isView="isView"></customer-save>
    </el-dialog>
  </div>
</template>

<script>
import CustomerSave from '@/components/customer/save';
import CustomerTag from '@/components/customer/tag';
import EmployeeSelect from '@/components/employee/select';
export default {
  name: 'customerList',
  components: {
    CustomerSave,
    CustomerTag,
    EmployeeSelect
  },
  created() {
    this.getData();
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      isView: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: '',
        customer_tag: '',
        employee_id: '',
        is_succ: ''
      },
      num: 0,
      selectedIds: []
    };
  },
  methods: {
    //新增/编辑
    dialog(row, isView = false) {
      this.isView = isView;
      this.dialogShow = true;
      this.dialogTitle = '添加客户';
      if (row) {
        this.dialogTitle = isView ? '查看信息' : '编辑客户';
        this.$nextTick(() => {
          this.$refs.customerSaveRef.setData(row.id);
        });
      }
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length == 0 && !id) {
        this.$message.warning('未选中数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            ids: this.selectedIds.join(',')
          };
          if (id) {
            params.ids = id;
          }
          this.loading = true;
          await this.$api.customer.delete(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      await this.$api.customer.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.dialogShow = false;
      this.getData();
    }
  }
};
</script>
<style>
.el-tooltip__popper {
  max-width: 200px !important;
  white-space: pre-line !important;
  line-height: 1.8 !important;
  padding: 10px !important;
}
</style>
